import PropTypes from 'prop-types'
import {useState} from 'react'
import {connect} from 'react-redux'
import {updateResource} from 'redux-json-api'

import {Cancel, Continue, ControlButton} from '../../../../shared_components/ButtonTypes'
import FirmActions from '../../actions/FirmActions'
import Modal from '../../../../shared_components/Modal'
import {useNotificationContext} from '../../../../shared_components/notifications/NotificationContext'

import './completeFirmSetup.scss'


export const CompleteFirmSetup = ({firmId, firmName, updateResource: updateResourceProp}) => {
  const {alwaysNotify} = useNotificationContext()

  const [processing, setProcessing] = useState(false)
  const [showModal, setShowModal] = useState(false)

  // The update keeps running once submitted, so block Cancel/the modal's close
  // affordance while it is in flight - otherwise the modal could be dismissed
  // into an invisible loading state and reopened mid-request.
  const closeModal = () => {
    if (processing) return

    setShowModal(false)
  }

  const completeSetup = () => {
    setProcessing(true)

    updateResourceProp({
      type: 'firms',
      id: firmId,
      attributes: {'pending-setup': false}
    }).then(() => {
      setProcessing(false)
      // Close directly: closeModal's guard still sees the stale processing value
      // from this render's closure.
      setShowModal(false)
      alwaysNotify.shortSuccess('Firm setup marked as complete. Held client invitations will now be sent.')
      // The firm admin pages still render from the legacy firm store, so refresh
      // it to clear the pending-setup badge and hide this control.
      FirmActions.fetchFirm(firmId)
    }).catch(() => {
      setProcessing(false)
      alwaysNotify.shortError("We're sorry, but something went wrong while completing this firm's setup. Please try again.")
    })
  }

  return (
    <div className='complete-firm-setup'>
      <ControlButton
        buttonText='Complete firm setup'
        disabled={processing}
        onClick={() => setShowModal(true)}
      />
      <Modal closer={closeModal} visible={showModal}>
        <div className='modal-header'>Mark this firm&apos;s setup as complete?</div>
        <p className='sub-header'>You are about to complete the setup of {firmName}.</p>
        <ul>
          <li>This firm was created automatically from a Sales Studio order and is awaiting manual setup.</li>
          <li>Make sure the firm&apos;s details, licensing, cobranding, and settings have been reviewed first.</li>
          <li>Held client invitations will be sent automatically to clients with a valid email address.</li>
          <li>Clients with a placeholder email will be invited once a real email address is provided.</li>
        </ul>
        <div className='button-group'>
          <Cancel disabled={processing} onClick={closeModal} />
          <Continue loading={processing} onClick={completeSetup}>Complete setup</Continue>
        </div>
      </Modal>
    </div>
  )
}

CompleteFirmSetup.propTypes = {
  firmId: PropTypes.string.isRequired,
  firmName: PropTypes.string.isRequired,
  updateResource: PropTypes.func.isRequired
}

export default connect(null, {updateResource})(CompleteFirmSetup)
